/**
 * FileDownload hook for handling file downloads
 */
export const FileDownload = {
  mounted() {
    // Listen for download events from the server
    this.handleEvent("download_file", ({ filename, content, mime_type = "text/csv" }) => {
      this.downloadFile(filename, content, mime_type);
    });
  },

  downloadFile(filename, content, mimeType) {
    // Create a blob with the content
    const blob = new Blob([content], { type: mimeType });

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element and trigger download
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = filename;

    // Append to body, click, and remove
    document.body.appendChild(a);
    a.click();

    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  },
};
